// eslint-disable-next-line
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PFSPartnersRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Grab the current path, replace the base segment
    const newPath = location.pathname.replace('/partners', '/who-we-trust');
    // Use React Router's navigate with replace:true to maintain SPA feel without full page reload
    navigate(newPath + location.search, { replace: true });
  }, [navigate, location]);

  return null;
};

export default PFSPartnersRedirect;
